import apiClient from '../apiClient';
import type { EmailMessage, GetMessagesOptions, SendMessageOptions, EmailProvider } from './types';

/**
 * Outlook Service (Backend-first)
 *
 * Enterprise rules:
 * - No OAuth tokens in the browser
 * - All provider calls go through backend (encrypted token storage)
 */

export async function initiateAuth(): Promise<void> {
  const { OAuthManager } = await import('../auth/OAuthManager');
  const oauthManager = new OAuthManager();
  await oauthManager.initiateOAuth('outlook');
}

export async function handleCallback(code: string): Promise<boolean> {
  const response = await apiClient.post<{ success: boolean }>('/api/email/outlook/callback', {
    code,
  });
  return Boolean(response?.success);
}

export async function fetchMessages(options: GetMessagesOptions = {}): Promise<EmailMessage[]> {
  const response = await apiClient.get<{ success: boolean; messages: EmailMessage[] }>(
    '/api/email/outlook/messages',
    { params: options }
  );
  if (!response.success) throw new Error('Failed to fetch Outlook messages');
  return response.messages || [];
}

export async function sendMessage(message: SendMessageOptions): Promise<void> {
  await apiClient.post('/api/email/outlook/send', message);
}

export async function deleteMessage(messageId: string): Promise<void> {
  await apiClient.delete(`/api/email/outlook/messages/${messageId}`);
}

export function isSupportedProvider(provider: EmailProvider): boolean {
  return provider === 'outlook';
}
